import React, { useRef, useState } from 'react';
import SetItemDetailTitle from './SetItemDetailTitle';
import useDetailsSortAndFilter from './hook/useDetailsSortAndFilter';
import {useSetDetailsSelectors} from './hook/useSetDetailsSelectors';
import SetItemDetailsImageSection from './SetItemDetailsImageSection';
import SetItemDetailsCondensedList from './SetItemDetailsCondensedList';
import {isMobileDevice } from 'src/utils/util'; 
import {
    TemplateContainer,
    LineSeparator,
    MainSection,
    DropDownStyle,
    StyledSortIcon,
    StyledDiv,
    SetItemCardContainer,
    MainWrapper
} from './SetDetails.styled';
import { useSetItemDetailsEffects } from './hook/useSetItemDetailsEffects';
import {
    getMaxLength, 
    getInitialList,   
} from 'src/common/organisms/setItemDetails/helperFunction/helperFunctions';
import SortDescending from 'src/assets/images/SortDescending.svg';
import SortGeneral from 'src/assets/images/SortGeneral.svg';
import TabControl from 'src/common/refactoredComponents/tabControl/tabControl';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import Select from 'src/common/refactoredComponents/select/Select';
import SetsAndItems from 'src/common/organisms/setsanditems/SetsAndItems'; 
import {  
    getProductDetails 
} from 'src/pages/scheduleSurgery/redux/actions/index';
import {
    getProductDetails as getConsignmentAddProductDetails, 
} from 'src/pages/consignmentAdd/redux/actions/index';
import {
    getProductDetails as getEquityProductDetails, 
} from 'src/pages/equity/redux/actions';
import { useDispatch } from 'react-redux';
import { ProductDetailsFilter } from 'src/constants/productConstants'; 
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import ViewLargeImage from 'src/common/refactoredComponents/viewLargeImage/viewLargeImage';
import SortAscending from 'src/assets/images/SortAscending.svg';
import { clearValidatedProducts,
} from 'src/pages/scheduleSurgery/redux/actions';
import { clearValidatedProducts as consignmentAddClearValidatedProducts,
} from 'src/pages/consignmentAdd/redux/actions';
import { clearValidatedProducts as clearEquityValidatedProducts,
} from 'src/pages/equity/redux/actions';
import { BASE_TEXT_PX, TITLE_FONT_COLOR,  FONT_FAMILY_DEMI, DARK_GRAY_FONT_COLOR
    } from 'src/styles/fonts/MCFontConstants';
import { EQUITYORDERTYPE } from 'src/pages/equity/components/common/constants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export default function index({
    handleClose,
    item,
    onItemClick = () => {},
    previousCfn,
    onAddClick,
    paddingBottom,
    showBackText,
    onBackClick,
    backText,
    isOnlyPlusButton,
    onOpen = () => {},
    onClose = () => {},
    isEquity,
    moreTemplates,
    isConsignmentAdd,
    marginRight,
    isSetDetail,
    isSurgery=false,
    cartFooterMargin='',
    hasTag=false,
    isOrderDetail
}) 
{
    const [selectedSegment, setSelectedSegment] = useState('0');
    const {
        countryISOCode,
        isLanguageChanged,
        isCondensedView,
        data,
        loading,
        initialList,
    } = useSetDetailsSelectors({ isEquity, isConsignmentAdd, isSetDetail, selectedSegment});
    // State hooks
    const [dropdownCode] = useState('ProductCode-asc');
    const [hideSortDropdown, setSortDropDown] = useState(true);
    const [sortValue, setSortValue] = useState('1');
    const [sortedRelatedValue, setSortedRelatedValue] = useState('1');
    const [viewLarge, setViewLarge] = useState(false);
    const [relatedSortOption, setRelatedSortOption] = useState([]);
    const [selectedRelatedSortOption, setSelectedRelatedSortOption] =
        useState('');
    const [, setQuantityValue] = useState(0);
    const { t } = useTranslation();
    const orientationChangedRef = useRef(false);
    
    // Redux hooks
    const dispatch = useDispatch();

    const { getSortOptionForRelatedProduct,
            handleFilter,
            handleListFilter} = useDetailsSortAndFilter({
                            setRelatedSortOption,
                            selectedSegment,
                            relatedSortOption,
                            setSelectedRelatedSortOption,
                            setSortedRelatedValue,
                            setSortValue,
                            isConsignmentAdd,
                            isSetDetail,
                            initialList,
                            isEquity,
                            data,
                            item
    });
    // Effects (moved to custom hook)
    useSetItemDetailsEffects({
        item,
        dropdownCode,
        setSelectedSegment,
        getInitialList,
        dispatch,
        isEquity,
        isConsignmentAdd,
        getEquityProductDetails,
        getConsignmentAddProductDetails,
        getProductDetails,
        EQUITYORDERTYPE,
        setQuantityValue,
        data,
        loading,
        selectedSegment,
        setSortDropDown,
        getSortOptionForRelatedProduct,
        isSetDetail,
    });
    const resourceType = isSetDetail
        ? 'BILL_OF_MATERIALS,RELATED_PRODUCTS'
        : 'FOUND_IN_SETS,RELATED_PRODUCTS';
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.mobileDevice;
    const isTablet =
        winWidth > sizes.smalDevice && winWidth < sizes.largeDevice;
    const modalPadding = winWidth >= 834 ? '10px 10px' : winWidth >= 820 ? '60px 10px' : '0 10px';
    
    const openImagePopup = () => {
        setViewLarge(true);
    };

    const closeImageDisplay = () => {
        setViewLarge(false);
    }; 

    const sortIconSelection = (dropdownCode) => {
        if (dropdownCode == '1' || dropdownCode == '3') {
            return SortAscending;
        } else {
            return SortDescending;
        }
    };

    const sortIconSelectionValue = sortIconSelection(sortValue);
    const setData = isSetDetail? data?.billOfMaterials:data?.foundInSets || [] ;
    const isConAddSetDetailHeader = isConsignmentAdd && isSetDetail || false;
    const isEquitySetDetailHeader = isEquity && isSetDetail || false;
    const isConAddItemDetail = isConsignmentAdd && !isSetDetail || false;
    const isEquityItemDetail = isEquity && !isSetDetail || false;

    useEffectWithErrorLogging(() => {
        const handleOrientationChange = () => {
            orientationChangedRef.current = true;
        };
        window.addEventListener('orientationchange', handleOrientationChange);
 
        const clearValidationProducts = () => {
            isConsignmentAdd
                ? dispatch(consignmentAddClearValidatedProducts())
                : isEquity
                ? dispatch(clearEquityValidatedProducts())
                : dispatch(clearValidatedProducts());
        };
 
        // clearValidationProducts();
 
        return () => {
            window.removeEventListener('orientationchange', handleOrientationChange);
            // Only clear if not due to orientation change
            if (!orientationChangedRef.current) {
                clearValidationProducts();
            }
        };
    }, []);

    return (
        <>
            {loading ? (
                <>
                    {window.innerWidth > sizes.mobileDevice ? (
                        <Spinner id="common-setItemDetails-setItemDetails-loadingSpinner" />
                    ) : (
                        <Spinner
                            id="common-setItemDetails-setItemDetails-mobileLoadingSpinner"
                            height="calc(100vh - 165px)"
                            animation="border"
                            variant="primary"
                            small
                        />
                    )}
                </>
            ) : (
                <>
                    <MainWrapper isCondensedView={isCondensedView} id="setItemDetails-mainWrapper">
                        <SetItemDetailTitle
                            isCondensedView={isCondensedView}
                            previousCfn={previousCfn}
                            showBackText={showBackText}
                            onBackClick={onBackClick}
                            handleClose={handleClose}
                            backText={backText}
                            t={t}
                            isMobileView={isMobileView}
                            sizes={sizes}
                            isSetDetail={isSetDetail}
                            resourceType={resourceType}
                        />

                        <TemplateContainer
                            paddingBottom={paddingBottom}
                            isCondensedView={isCondensedView}
                            mbPadding={isCondensedView && '0px'}
                            width={!isCondensedView && '89%'}
                            mbMargin={!isCondensedView && 'auto'}
                        >
                            <SetItemDetailsImageSection
                                isSurgery={isSurgery}
                                isCondensedView={isCondensedView}
                                previousCfn={previousCfn}
                                showBackText={showBackText}
                                onBackClick={onBackClick}
                                handleClose={handleClose}
                                backText={backText}
                                t={t}
                                moreTemplates={moreTemplates}
                                sizes={sizes}
                                data={data}
                                isEquity={isEquity}
                                isOnlyPlusButton={
                                    isConAddSetDetailHeader || isEquitySetDetailHeader? false:
                                    isOnlyPlusButton}
                                onAddClick={onAddClick}
                                index={0}
                                marginRight={marginRight}
                                openImagePopup={openImagePopup}
                                isSetDetail={true}
                                isOrderDetail={isOrderDetail}
                                isConsignmentAdd={isConsignmentAdd}
                            />
                            {window.innerWidth > sizes.mobileDevice && (
                                <LineSeparator borderTop={'1px solid #EBEBEB'} />
                            )}

                            <SetItemDetailsCondensedList
                                isCondensedView={isCondensedView}
                                data={data}
                                sizes={sizes}
                                t={t}
                                isMobileDevice={isMobileDevice}
                                isLanguageChanged={isLanguageChanged}
                                sortIconSelectionValue={sortIconSelectionValue}
                                sortValue={sortValue}
                                ProductDetailsFilter={ProductDetailsFilter}
                                handleListFilter={handleListFilter}
                                onOpen={onOpen}
                                onClose={onClose}
                                onItemClick={onItemClick}
                                setSelectedSegment={setSelectedSegment}
                                isOnlyPlusButton={isConAddItemDetail || isEquityItemDetail? false 
                                    : isOnlyPlusButton}
                                marginRight={marginRight}
                                onAddClick={onAddClick}
                                getMaxLength={getMaxLength}
                                isTablet={isTablet}
                                countryISOCode={countryISOCode}
                                relatedSortOption={relatedSortOption}
                                sortedRelatedValue={sortedRelatedValue}
                                hideSortDropdown={hideSortDropdown}
                                isConsignmentAdd={isConsignmentAdd}
                                isEquity={isEquity}
                                isSetDetail={isSetDetail}
                            />
                            {!isCondensedView && (
                                <>
                                    <MainSection>
                                        <TabControl
                                            id={
                                                isSetDetail
                                                    ? t('common.itemsLabel')
                                                    : t('scheduleSurgery.itemDetails.foundInSets')
                                            }
                                            tabOneTitle={
                                                isSetDetail
                                                    ? t('common.itemsLabel')
                                                    : t('scheduleSurgery.itemDetails.foundInSets')
                                            }
                                            tabOneChildren={<></>}
                                            tabTwoTitle={t('common.relatedText')}
                                            tabViewWidth={
                                                isSetDetail
                                                    ? '232px !important'
                                                    : data?.foundInSets?.length > 0
                                                    ? '280px !important'
                                                    : '232px !important'
                                            }
                                            tabOneId="common-index-organisms-foundInSets"
                                            tabTwoId="common-index-organisms-relatedProducts"
                                            tabViewHeight={'40px'}
                                            tabFontFamily={FONT_FAMILY_DEMI}
                                            tabFontSize={BASE_TEXT_PX}
                                            tabFontColor={DARK_GRAY_FONT_COLOR}
                                            border={'1px solid #D7DBDB'}
                                            tabViewWidthMediumDevice={
                                                isSetDetail ? '232px !important' : '280px !important'
                                            }
                                            selectedTabState={val => setSelectedSegment(val.toString())}
                                        />
                                        {!hideSortDropdown && (
                                            <DropDownStyle
                                                isCondensedView={isCondensedView}>
                                                <StyledSortIcon>
                                                    <img src={SortGeneral} />
                                                </StyledSortIcon>
                                                <Select
                                                    value={
                                                        selectedSegment === '0'
                                                            ? sortValue
                                                            : selectedRelatedSortOption
                                                    }
                                                    hideClear
                                                    options={
                                                        selectedSegment === '0'
                                                            ? ProductDetailsFilter()
                                                            : relatedSortOption
                                                    }
                                                    onChange={value => handleFilter(value)}
                                                    placeholder={t('common.selectText')}
                                                    optionValue="id"
                                                    optionLabel={'title'}
                                                    onOpen={onOpen}
                                                    onClose={onClose}
                                                />
                                            </DropDownStyle>
                                        )}
                                    </MainSection>
                                    {selectedSegment === '0' ? (
                                        <SetItemCardContainer
                                            scrollBarBackgroundColor={'#808080'}
                                            scrollBarBackGroundColorOnHover={'#00000029'}
                                        >
                                            {setData?.map((item, index) => {
                                                if (item.message) {
                                                    return (
                                                        <StyledDiv margin={'10px 0px 0px 5px'} key={index}>
                                                            {item.message}
                                                        </StyledDiv>
                                                    );
                                                } else {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <SetsAndItems
                                                                cartFooterMargin={cartFooterMargin}
                                                                isScheduleSurgery={isSurgery}
                                                                height={'fit-content'}
                                                                className="cards"
                                                                isConsignmentAdd={isConsignmentAdd}
                                                                isOnlyPlusButton={
                                                                    isSetDetail
                                                                        ? isOnlyPlusButton
                                                                        : !(
                                                                              isConsignmentAdd ||
                                                                              isEquity
                                                                          ) && isOnlyPlusButton
                                                                } 
                                                                setOrItemDetails={item}
                                                                addCard={() => onAddClick(item)}
                                                                boxShadow={
                                                                    window.innerWidth <= sizes.mobileDevice
                                                                        ? 'none'
                                                                        : '0px 0px 6px #00000029'
                                                                }
                                                                itemQuantity={true}
                                                                showType={false}
                                                                onSetItemClick={onItemClick}
                                                                showBrand={true}
                                                                contentPadding={
                                                                    window.innerWidth <= sizes.mobileDevice &&
                                                                    '0px'
                                                                }
                                                                setNameColor= {TITLE_FONT_COLOR}
                                                                setNameFontSizeMobile= {BASE_TEXT_PX}
                                                                setNameFontSizeDesktop={BASE_TEXT_PX}
                                                                clickable
                                                                marginOnLargeDevice={'10px 12px 5px 5px'}
                                                                mobileWidth={'99%'}
                                                                width={'47.5%'}
                                                                minWidth={'47.5%'}
                                                                selectedSegment={isSetDetail ? selectedSegment : null}
                                                                hasTag={hasTag}
                                                            />
                                                            {window.innerWidth <= sizes.mobileDevice && (
                                                                <LineSeparator
                                                                    borderTop={'2px solid #f5f5f5'}
                                                                    margin={'-18px 0px 0px 0px'}
                                                                />
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                }
                                            })}
                                        </SetItemCardContainer>
                                    ) : (
                                        <SetItemCardContainer
                                            scrollBarBackgroundColor={'#808080'}
                                            scrollBarBackGroundColorOnHover={'#00000029'}
                                        >
                                            {data?.relatedProducts &&
                                                data.relatedProducts.map((item, index) => {
                                                    if (item.message) {
                                                        return (
                                                            <StyledDiv margin={'10px 0px 0px 5px'} key={index}>
                                                                {item.message}
                                                            </StyledDiv>
                                                        );
                                                    } else {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <SetsAndItems
                                                                    cartFooterMargin={cartFooterMargin}
                                                                    isScheduleSurgery={isSurgery}
                                                                    className="cards"
                                                                    height={'fit-content'}
                                                                    isOnlyPlusButton={isOnlyPlusButton}
                                                                    setOrItemDetails={item}
                                                                    addCard={() => onAddClick(item)}
                                                                    boxShadow={
                                                                        window.innerWidth <= sizes.mobileDevice &&
                                                                        'none'
                                                                    }
                                                                    showType={false}
                                                                    showBrand={true}
                                                                    countAndTypePosition={'flex-end'}
                                                                    contentPadding={
                                                                        window.innerWidth <= sizes.mobileDevice &&
                                                                        '0px'
                                                                    }
                                                                    onSetItemClick={onItemClick}
                                                                    setNameColor= {TITLE_FONT_COLOR}
                                                                    setNameFontSizeMobile= {BASE_TEXT_PX}
                                                                    setNameFontSizeDesktop= {BASE_TEXT_PX}
                                                                    clickable
                                                                    marginOnLargeDevice={'10px 12px 5px 5px'}
                                                                    mobileWidth={'99%'}
                                                                    width={isSetDetail ? '47.5%' : '45%'}
                                                                    minWidth={isSetDetail ? '47.5%' : '45%'}
                                                                    isEquity={isEquity}
                                                                    selectedSegment={selectedSegment}
                                                                    hasTag={hasTag} 
                                                                />
                                                                {window.innerWidth <= sizes.mobileDevice && (
                                                                    <LineSeparator
                                                                        borderTop={'2px solid #f5f5f5'}
                                                                        margin={'-18px 0px 0px 0px'}
                                                                    />
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    }
                                                })}
                                        </SetItemCardContainer>
                                    )}
                                </>
                            )}
                        </TemplateContainer>
                        {viewLarge && (
                            <ModalDialog
                                modalHeight={'fit-content'}
                                modalMaxHeight={winWidth >= 820 && winWidth < sizes.mediumDevice ? '114vh' : '85vh'}
                                overflowY={'hidden'}
                                maxWidth={'841px'}
                                backdropFilter={'blur(2px)'}
                                zIndex={'10000'}
                                marginTop={'10px'}
                                padding={modalPadding}
                                isFromMobile={true}
                                height={'101.5%'}
                                mobilePaperFullScreenHeight={winWidth <= 375 ? '75vh' : '60vh'}
                                isFromBomChangeNotification={true}
                                containerWidth={'92%'}
                                containerRight={'4%'}
                                background={'#ffffff'}
                                handleClose={() => closeImageDisplay()}
                            >
                                <ViewLargeImage
                                    images={data}
                                    closeImageDisplay={closeImageDisplay}
                                    isItemDetails={isSetDetail ? false : true}
                                />
                            </ModalDialog>
                        )}
                    </MainWrapper>
                </>
            )}
        </>
    );
}
